import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown as HeroDropdown } from '@heroui/react';
export const Dropdown = ({ className, children, ...props }) => {
    return (_jsx(HeroDropdown, { className: className, ...props, children: children }));
};
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map